import { render } from "./RolesSelector.vue?vue&type=template&id=4ceebd48"
import script from "./RolesSelector.vue?vue&type=script&lang=js"
export * from "./RolesSelector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__